import { render, staticRenderFns } from "./commonUploadSentence.vue?vue&type=template&id=0e928f87&"
import script from "./commonUploadSentence.vue?vue&type=script&lang=js&"
export * from "./commonUploadSentence.vue?vue&type=script&lang=js&"
import style0 from "./commonUploadSentence.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports